import React, { HTMLAttributes, ReactNode, useEffect, useRef, useState } from 'react'
import { IconFilter } from '../../icons/IconFilter'
import { BpButton } from '../../buttons/bp-button/BpButton'
import { Square } from '../../utility/square/Square'
import { IWithDropdownProps, withDropdown } from '../../../lib/hoc/WithDropdown'
import { useTranslation } from 'react-i18next'

export interface IFilterDropParams extends IWithDropdownProps {
  children?: ReactNode | undefined
  onSubmit?: () => void
  onClear?: () => void
  /** Поповер закрылся — здесь откатывают правки, не применённые через Apply Filters */
  onHide?: () => void
  values?: (string | number | boolean | undefined)[]
}

const Drop = ({
  children,
  open,
  onToggle,
  onSubmit,
  onClear,
  onHide,
  values = [],
}: IFilterDropParams & HTMLAttributes<HTMLElement>) => {
  const { t } = useTranslation()
  const [isHidden, setIsHidden] = useState(!open)
  const [counter, setCounter] = useState(0)
  const wasOpen = useRef(open)

  useEffect(() => {
    open ? setIsHidden(false) : setTimeout(() => setIsHidden(true), 150)
  })

  // только переход «открыт → закрыт»: на монтировании откат затёр бы значения из url
  useEffect(() => {
    if (wasOpen.current && !open) onHide?.()
    wasOpen.current = open
  }, [open])

  useEffect(() => {
    setCounter(values?.filter((value) => !!value).length)
  }, [values])

  return (
    <div className='relative table w-full select-none'>
      <BpButton
        active={open}
        className='relative h-[48px] w-full'
        size='lg'
        type='button'
        onClick={onToggle}
      >
        <span className={'flex w-[15px] content-center items-center'}>
          <IconFilter />
        </span>
        <span
          className={`absolute -top-[4px] -right-[5px] rounded-[4px] bg-[#00326D] py-[2px] px-[6px] text-[12px] ${
            !counter && 'hidden'
          }`}
        >
          {counter}
        </span>
      </BpButton>
      <div
        className={`absolute right-0 top-[54px] w-[320px] max-w-[85vw] transition-opacity duration-150 ${open ? 'pointer-events-auto opacity-100' : 'pointer-events-none opacity-0'} ${isHidden && 'invisible'} z-[55]`}
      >
        <Square className='left-0 flex flex-col' depth='200'>
          <div className={'relative'}>
            <div
              className={
                'scrollbar-hide flex max-h-[400px] min-h-[300px] flex-col gap-[18px] overflow-scroll p-[24px]'
              }
            >
              {children}
            </div>
          </div>
          <div className='flex flex-col gap-[18px] border-t-[3px] border-t-focus-500/[0.02] p-[24px] md:flex-row'>
            <BpButton type='button' onClick={onSubmit}>
              {t('buttons.applyFilters')}
            </BpButton>
            <BpButton theme='outline' type='button' onClick={onClear}>
              {t('buttons.clearSelected')}
            </BpButton>
          </div>
        </Square>
      </div>
    </div>
  )
}

export const FilterDrop = withDropdown(Drop)
